/**
 * Misc string constants
 */
const stringConstants = {
	SIGN_IN: 'Sign In',
	SIGN_OUT: 'Sign Out',
	HELLO: 'Hello, '
};

export default stringConstants;